import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { usePWAInstall } from '../../../hooks/usePWAInstall';

import { ensureArray, ensureJsonObject } from '../../../utils/validateResponseApi';
import { callApi } from '../../../services/api.service';

import { LoadData, getAllDocs } from '../../../redux/actions/sharedViews';
import { actionTypes } from "../../../redux/contants/actionTypes";

import { useSharedViews } from '../../../hooks/useSharedViews';
import { useCompanyConfiguration } from '../../../hooks/useCompanyConfiguration';

export function useManageSharedViews(config) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [{ userSession }] = useDataAuth();
    const { isMobileScreen } = usePWAInstall();
    const [companies, setCompanies] = useState([]);

    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [isFirstLoadDone, setIsFirstLoadDone] = useState(true);
    const [configuration, setConfiguration] = useState(null);
    const [expandedId, setExpandedId] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [buttons, setButtons] = useState([]);
    const [columns, setColums] = useState([]);

    let valor = null;

    const [DocManager] = useSharedViews();
    const {
        listAllDocs,
        isLoading,
        rowsChecked,
        filters,
        pagination,
        counter,
        id_user_action,
        id_company,
        select_company,
        resetInitState,
        setIdUserAction,
    } = DocManager;

    const {
        selectedCompanyId,
        startViewAs,
        endViewAs
    } = useCompanyConfiguration();

    const resetState = useCallback(() => {
        setIsFirstLoadDone(true);
        resetInitState();
        endViewAs();
    }, [resetInitState, endViewAs]);

    const GetAllDocs = useCallback((filters, pagination, append = false) => {
        if (id_user_action)
            dispatch(getAllDocs(userSession.token, id_user_action, filters, pagination, append));
    }, [dispatch, userSession.token, id_user_action]);

    //#region Check Handlers
    const isCheck = (id) => rowsChecked.includes(id);
    const handleRowsChecked = (obj) => dispatch(LoadData(actionTypes.rowsChecked, obj));
    const handleCheckAll = ({ target: { checked } }) => handleRowsChecked(checked ? listAllDocs.map((item) => item.id) : []);

    const handleCheck = (id) => {
        const isSelected = rowsChecked.includes(id);
        if (isSelected) {
            handleRowsChecked(rowsChecked.filter(row => row !== id));
            if (expandedId === id) {
                setExpandedId(null);
            }
        } else {
            handleRowsChecked([...rowsChecked, id]);
            setExpandedId(prev => prev === id ? null : id);
        }
    };
    //#end region Check Handlers

    //#region Pagination and Search Handlers
    const RefreshTable = () => GetAllDocs(filters, pagination);
    const updatePagination = (newPagination) => dispatch(LoadData(actionTypes.filterAndPagination, { filters, pagination: { ...pagination, ...newPagination } }));
    const updateFilters = (newFilters) => dispatch(LoadData(actionTypes.filterAndPagination, { filters: { ...filters, ...newFilters }, pagination }));

    const handleChangePage = (event, newPage) => {
        const pageNumber = newPage + 1;
        updatePagination({ pageNumber });
        GetAllDocs(filters, { ...pagination, pageNumber });
        handleRowsChecked([]);
    };

    const handleChangeRowsPerPage = (event) => {
        const pageSize = parseInt(event.target.value, 10);
        updatePagination({ pageNumber: 1, pageSize });
        GetAllDocs(filters, { pageNumber: 1, pageSize });
        handleRowsChecked([]);
    };

    const Search = (value, key) => {
        const newFilters = { ...filters, [key]: value };
        updateFilters(newFilters);
        updatePagination({ pageNumber: 1 });
        GetAllDocs(newFilters, { ...pagination, pageNumber: 1 });
        handleRowsChecked([]);
    };

    const ResetSearch = (key) => {
        const newFilters = { ...filters };
        delete newFilters[key];
        updateFilters(newFilters);
        GetAllDocs(newFilters, pagination);
        handleRowsChecked([]);
    };

    const handleLoadMore = () => {
        const hasFilters = Object.values(filters).some(v => v !== "");
        const append = isMobileScreen && !hasFilters;
        const nextPage = pagination.pageNumber + 1;
        updatePagination({ pageNumber: nextPage });
        GetAllDocs(filters, { ...pagination, pageNumber: nextPage }, append);
        handleRowsChecked([]);
    };
    //#end region Pagination and Search Handlers

    const handleConfirmAction = (dto, globalCompany = true) => {
        startViewAs(dto, globalCompany);
        dispatch(LoadData(actionTypes.setIdCompany, dto.id_company));
        dispatch(LoadData(actionTypes.isSelectCompany, true));
        const id_company = {
            "value": dto.id_company,
            "operator": "=",
            "type": "string"
        }
        const newFilters = { ...filters, id_company };
        updateFilters(newFilters);
        setOpenDialogCompany(false);
        setIsFirstLoadDone(false);
    }

    //     const fetchCompanysByIdUserAction = useCallback(async (idUserAction) => {
    //     try {
    //         const response = await callApi('company_select', 'SELECT_COMPANIES_BY_USER_ACTION_ID', { 'id_user_action': idUserAction }, userSession.token);
    //         if (response.status === 200 && response.data) {
    //             const companies = ensureArray(response.data);
    //             setCompanies(companies);
    //             if (companies.length === 1) {
    //                 //NO ES LA COMAPAñIA GLOBAL
    //                 console.log('Entro por company no global');
    //                 handleConfirmAction(companies[0], false);
    //             }
    //             else {
    //                 if (!selectedCompanyId) {
    //                     const dto = companies.find(p => p.id_company === selectedCompanyId);
    //                     if (dto) {
    //                         handleConfirmAction(dto);
    //                         return;
    //                     }
    //                     setOpenDialogCompany(true);
    //                 } else {
    //                     console.log();
    //                     const dto = companies.find(p => p.id_company === selectedCompanyId);
    //                     if (!dto && id_user_action && idUserAction === id_user_action) {
    //                         Cancel();
    //                     }
    //                     else
    //                     setOpenDialogCompany(true);
    //                 }
    //             }
    //         }
    //     } catch (err) {
    //         console.error("ERROR_fetchCompanys: ", err.message);
    //     }
    // }, [id_user_action, selectedCompanyId, userSession.token]);
    const fetchCompanysByIdUserAction = async (idUserAction) => {
        try {
            const response = await callApi('company_select', 'SELECT_COMPANIES_BY_USER_ACTION_ID', { 'id_user_action': idUserAction }, userSession.token);
            if (response.status === 200 && response.data) {
                const companies = ensureArray(response.data);
                setCompanies(companies);
                if (companies.length === 1) {
                    //NO ES LA COMAPAñIA GLOBAL
                    console.log('Entro por company no global');
                    handleConfirmAction(companies[0], false);
                }
                else {
                    const dto = companies.find(p => p.id_company === selectedCompanyId);
                    if (dto) {
                        handleConfirmAction(dto);
                        return;
                    }
                    setOpenDialogCompany(true);
                }
            }
        } catch (err) {
            console.error("ERROR_fetchCompanys: ", err.message);
        }
    };

    useEffect(() => {
        resetState();
        // Determinar el origen del config
        const incomingConfig =
            location.state?.config ?
                { ...location.state.config, title: location.state.config?.title }
                :
                config ? { ...config, title: "reportes" } : null;

        if (!incomingConfig) return;

        const cf = ensureJsonObject(incomingConfig?.configuration);
        setColums(ensureArray(cf.table));
        setButtons(ensureArray(cf.button));

        setConfiguration({
            configuration: incomingConfig.configuration,
            title: incomingConfig.name
        });

        if (cf?.select_company) {
            fetchCompanysByIdUserAction(incomingConfig?.id_user_action?.toString());
        }
        else {
            setIsFirstLoadDone(false);
        }
        setIdUserAction(incomingConfig?.id_user_action?.toString());
    }, [location.state?.config, config, selectedCompanyId]);

    useEffect(() => {
        if (!isFirstLoadDone) {
            GetAllDocs(filters, pagination);
        }
    }, [GetAllDocs, filters, pagination, isFirstLoadDone]);

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate("/home");
        resetState();
    }

    return {
        isMobileScreen,
        DocManager,
        configuration,
        buttons,
        columns,
        id_user_action,
        id_company,
        select_company,
        companies,
        openDialogCompany,
        expandedId,
        anchorEl,
        //REDUX DATA
        listAllDocs,
        isLoading,
        rowsChecked,
        filters,
        pagination,
        counter,
        //REDUX DATA
        // custom functions
        t,
        setAnchorEl,
        handleConfirmAction,
        handleChangePage,
        handleChangeRowsPerPage,
        Search,
        ResetSearch,
        RefreshTable,
        handleCheckAll,
        handleCheck,
        handleLoadMore,
        isCheck,
        Cancel,
        handleRowsChecked
        // custom functions
    }
}
